<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized">
  <div *ngIf="conference.allowPosters" class="alert alert-success mt-2 mb-5" role="alert">
    <div class="container">
      <div class="row h-100">
        <div class="col-md-9 my-auto">
          <h6 class="mb-0">NOTE: We are still accepting posters. Please click here to sign up!</h6>
        </div>
        <div class="col-md-3 text-right">
          <button type="button" [routerLink]="['/', conference.organization.slug, 'call-for-posters']" class="btn btn-secondary btn-sm">Add Poster</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!auth.user || !auth.isLoggedIn()" class="alert alert-danger mt-2 mb-5" role="alert">
    <div class="container">
      <div class="row h-100">
        <div class="col-md-9 my-auto">
          <h6 class="mb-0">Please login/create a free account to view the posters!</h6>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <ng-container *ngFor="let poster of posters">
      <div *ngIf="poster.posterSessionPostersVisible" class="col-md-3 col-lg-3 cbp-item graphic">
        <div class="cbp-item-wrapper">
          <a *ngIf="(auth.isLoggedIn() && poster.posterSessionAllowJoin) || auth.isSuperUser()" class="cbp-caption" [routerLink]="['/poster-session', poster.posterSessionId, 'posters', poster.id]">
            <img *ngIf="poster.posterAssetPath && !poster.posterThumbnailPath" class="rounded img-fluid" src="fetchimage?filename={{ poster.posterAssetPath }}&width=380&height=300"  />
            <img *ngIf="poster.posterThumbnailPath" class="rounded img-fluid" src="fetchimage?filename={{ poster.posterThumbnailPath }}&width=380&height=300"  />
            <img *ngIf="!poster.posterAssetPath && !poster.posterThumbnailPath" class="rounded img-fluid" src="https://via.placeholder.com/380x300?text=Poster"  />
            <div class="py-3">
              <h4 class="h6 text-dark mb-0">{{ poster.title }}</h4>
              <p class="small mb-0">
                <span class="mr-1" *ngFor="let author of poster.authors">{{ author.firstName + ' ' + author.lastName }}</span>
              </p>
            </div>
          </a>
          <div *ngIf="(!auth.isLoggedIn() || !poster.posterSessionAllowJoin) && !auth.isSuperUser()" class="cbp-caption">
            <img *ngIf="poster.posterAssetPath && !poster.posterThumbnailPath" class="rounded img-fluid" src="fetchimage?filename={{ poster.posterAssetPath }}&width=380&height=300"  />
            <img *ngIf="poster.posterThumbnailPath" class="rounded img-fluid" src="fetchimage?filename={{ poster.posterThumbnailPath }}&width=380&height=300"  />
            <img *ngIf="!poster.posterAssetPath && !poster.posterThumbnailPath" class="rounded img-fluid" src="https://via.placeholder.com/380x300?text=Poster"  />
            <div class="py-3">
              <h4 class="h6 text-dark mb-0">{{ poster.title }}</h4>
              <p class="small mb-0">
                <span class="mr-1" *ngFor="let author of poster.authors">{{ author.firstName + ' ' + author.lastName }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
